module.exports = __webpack_public_path__ + "static/media/PC6-5.caaae433.jpg";